import { render, staticRenderFns } from "./receivableSettlementDashboard.vue?vue&type=template&id=8365e3ea"
import script from "./receivableSettlementDashboard.vue?vue&type=script&lang=js"
export * from "./receivableSettlementDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8365e3ea')) {
      api.createRecord('8365e3ea', component.options)
    } else {
      api.reload('8365e3ea', component.options)
    }
    module.hot.accept("./receivableSettlementDashboard.vue?vue&type=template&id=8365e3ea", function () {
      api.rerender('8365e3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/receivableSettlementDashboard.vue"
export default component.exports